<template>
	<form class="s-w-full" @submit.prevent="onSubmit">
		<JBox class="s-relative s-p-10">
			<!-- Name -->
			<CFormInput
				:label="$t('templates.name_of_template')"
				componentName="JInputText"
				name="name"
				v-bind:class="{ 's-border-red-500': $v.form.name.$error }"
				v-model="form.name"
			/>
			<template v-if="$v.form.name.$dirty">
				<JBox class="s-text-red-500 s-text-sm" v-if="!$v.form.name.required">
					{{ $t("templates.field_required") }}
				</JBox>
			</template>

			<!-- Description -->
			<CFormInput
				:label="$t('templates.description')"
				componentName="JInputText"
				name="description"
				class="s-my-6"
				v-model="form.description"
			/>

			<!-- Template Type -->
			<CFormInput
				:label="$t('templates.template_type')"
				componentName="JSelect"
				:options="templateOptions"
				:value="templateType"
				name="template_type"
				class="s-mb-6"
				v-model="templateType"
			/>

			<!-- Email Mode (only for emailMjml templates) -->
			<CFormInput
				v-if="templateType === 'emailMjml'"
				:label="$t('templates.emailMode')"
				componentName="JSelect"
				:options="emailModeOptions"
				:value="emailMode"
				name="email_mode"
				class="s-mb-6"
				v-model="emailMode"
			/>

			<!-- Buttons -->
			<JFlex class="s-justify-between s-mt-8">
				<JButton type="submit" variant="default-light">{{ $t("templates.create") }}</JButton>
				<JButton variant="white" @click="$emit('cancel')">{{ $t("templates.cancel") }}</JButton>
			</JFlex>
		</JBox>
	</form>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import api from "@/api/api"
import { mutation } from "../api/queries"

export default {
	props: {},

	data() {
		return {
			isLoading: false,
			templateType: "wkhtmltopdf",
			emailMode: "mjml", // 'mjml' or 'plaintext'
			form: {
				name: "",
				description: "",
			},
			templateOptions: [
				{ name: this.$t("templates.htmlToPdf"), value: "wkhtmltopdf" },
				{ name: this.$t("templates.pdfDrawing"), value: "pdfDrawing" },
				{ name: this.$t("templates.emailMjml"), value: "emailMjml" },
				{ name: this.$t("templates.sms"), value: "smsNotification" },
				{ name: this.$t("templates.dynamic"), value: "dynamic" },
				// { name: this.$t("templates.notification"), value: "notification" },
				// { name: this.$t("templates.function"), value: "function" }
			],
			emailModeOptions: [
				{ name: this.$t("templates.emailModeMjml"), value: "mjml" },
				{ name: this.$t("templates.emailModePlaintext"), value: "plaintext" },
			],
			mjml:
				"<mjml>\n    <mj-body>\n        <mj-section>\n            <mj-column>\n                <mj-text>Default starting template</mj-text>\n            </mj-column>\n        </mj-section>\n    </mj-body>\n</mjml>",
			plainText: "Default starting plaintext template",
		}
	},

	validations: {
		form: {
			name: { required },
		},
	},

	methods: {
		async onSubmit() {
			this.$v.$touch()
			if (this.$v.$invalid) return

			if (this.templateType === "wkhtmltopdf") {
				await api({
					query: mutation.createWkhtmltopdfTemplate,
					variables: {
						input: {
							name: this.form.name,
							description: this.form.description,
							graphQlQuery: "",
							html: "<p>I am a paragraph</p>",
							marginSettings: { top: 10, right: 0, bottom: 10, left: 0 },
							headerSettings: {
								spacing: 0,
								html: "<!DOCTYPE html><p>I am a header</rp>",
							},
							footerSettings: { spacing: 0, html: "<p>I am a footer</p>" },
						},
					},
				})
			}

			if (this.templateType === "emailMjml") {
				const input = {
					name: this.form.name,
					description: this.form.description,
					subject: "",
				}

				if (this.emailMode === "mjml") {
					input.mjml = this.mjml
				} else {
					input.plainText = this.plainText
				}

				await api({
					query: mutation.createEmailMjmlTemplate,
					variables: {
						input: input,
					},
				})
			}

			if (this.templateType === "notification") {
				await api({
					query: mutation.createNotificationTemplate,
					variables: {
						input: {
							name: this.form.name,
							description: this.form.description,
						},
					},
				})
			}

			if (this.templateType === "pdfDrawing") {
				await api({
					query: mutation.createPdfDrawingTemplate,
					variables: {
						input: {
							name: this.form.name,
							description: this.form.description,
						},
					},
				})
			}

			if (this.templateType === "smsNotification") {
				await api({
					query: mutation.createSmsTemplate,
					variables: {
						input: {
							name: this.form.name,
							description: this.form.description,
							bodyLiquid: "",
						},
					},
				})
			}

			if (this.templateType === "dynamic") {
				await api({
					query: mutation.createDynamicTemplate,
					variables: {
						input: {
							name: this.form.name,
							description: this.form.description,
						},
					},
				})
			}

			if (this.templateType === "function") {
				await api({
					query: mutation.createFunctionTemplate,
					variables: {
						input: {
							name: this.form.name,
							description: this.form.description,
							engine: {
								name: "excel",
								runTime: "excel",
							},
						},
					},
				})
			}

			this.$emit("save")
		},
	},
}
</script>
